module.exports = __webpack_public_path__ + "img/ynlogo.ac89b931.png";